import Helpers from './helpers';
import AsyncForm from './async-form';

export default class ExitPopup {
	constructor() {
		const cookieValue = 'coldProfessionalSignupPopup';
		if (!document.cookie.includes(cookieValue)) {
			document.addEventListener('mouseout', ExitPopup.mouseEvent);
		}
	}

	static mouseEvent(e) {
		if (!e.toElement && !e.relatedTarget && e.clientY < 10) {
			window.dispatchEvent(
				new CustomEvent('lightbox-show-by-template-id', {
					detail: { templateId: 'coldProfessionalSignupPopup' },
				})
			);
			ExitPopup.renderActions();
			document.removeEventListener('mouseout', ExitPopup.mouseEvent);
		}
	}

	static renderActions() {
		if (document.querySelectorAll('[data-async-form]').length > 0) {
			this.asyncForm = new AsyncForm({ elements: document.querySelectorAll('[data-async-form]') });
		}
		document.querySelector('.lightbox__close').addEventListener('click', () => {
			Helpers.setCookie('dngExitPopUpCookie', 'coldProfessionalSignupPopup', 30);
		});
		const lightbox = document.querySelector('.lightbox__content');
		lightbox.querySelector('.submit').addEventListener('click', () => {
			Helpers.setCookie('dngExitPopUpCookie', 'coldProfessionalSignupPopup', 10 * 365);
		});
	}
}
